import React from 'react';

const AccountOrdersHistoryTastic: React.FC = () => {
  return <></>;
};

export default AccountOrdersHistoryTastic;
